import { NgModule } from "@angular/core";
import { FormSectionDirective, SectionDirective } from "./section.directive";

@NgModule({
    imports: [],
    exports: [
        SectionDirective,
        FormSectionDirective,
    ],
    declarations: [
        SectionDirective,
        FormSectionDirective,
    ],
    providers: [],
})
export class SectionsModule {
}
